<template>
  <div>

    <div class="code-block">
      <pre><code>{{ iframeCode }}</code></pre>
      <button class="copy-btn copy-btn--code" @click="clickedCopyToClipboard(iframeCode)">
        <i class="fa fa-clipboard"></i>
      </button>
    </div>

    <div class="widget-preview-container" :key="previewKey" v-html="boundCodeForWidgetPreview">
    </div>

  </div>
</template>

<script>

export default {
  name: "WidgetPreview",
  props: {
    formModel: Object
  },
  data() {
    return {
      iframeCode: '',
      iframeWidth: 390,
      iframeHeight: 0,
    }
  },
  computed: {
    // Determine the base domain to use (whitelabel domain or ferryhopper)
    baseDomain() {
      if (this.formModel.whitelabelDomain && this.formModel.whitelabelDomain.value) {
        return `https://${this.formModel.whitelabelDomain.value}`;
      }
      return 'https://www.ferryhopper.com';
    },
    // Build URL parameters based on form model
    buildUrlParams() {
      const params = [];
      
      // Affiliate code
      if (this.formModel.affiliationCode.value) {
        params.push(`aff_uid=${this.formModel.affiliationCode.value}`);
      }
      
      // Primary color
      if (this.formModel.themeColor && this.formModel.themeColor.value && this.formModel.themeColor.value !== '#01C3A7') {
        params.push(`color=${this.formModel.removeHashFromColor(this.formModel.themeColor.value)}`);
      }
      
      // Pre-filled search values
      if (this.formModel.fromPort && this.formModel.fromPort.value) {
        params.push(`from=${this.formModel.fromPort.value}`);
      }
      if (this.formModel.toPort && this.formModel.toPort.value) {
        params.push(`to=${this.formModel.toPort.value}`);
      }
      if (this.formModel.oneway && this.formModel.oneway.value) {
        params.push('oneway=true');
      }
      
      // Display options
      const options = this.formModel.buildOptionsString ? this.formModel.buildOptionsString() : '';
      if (options) {
        params.push(`options=${options}`);
      }
      
      return params.length > 0 ? `?${params.join('&')}` : '';
    },
    // Build URL params for preview (without affiliate code)
    buildPreviewUrlParams() {
      const params = [];
      
      // Primary color
      if (this.formModel.themeColor && this.formModel.themeColor.value && this.formModel.themeColor.value !== '#01C3A7') {
        params.push(`color=${this.formModel.removeHashFromColor(this.formModel.themeColor.value)}`);
      }
      
      // Pre-filled search values
      if (this.formModel.fromPort && this.formModel.fromPort.value) {
        params.push(`from=${this.formModel.fromPort.value}`);
      }
      if (this.formModel.toPort && this.formModel.toPort.value) {
        params.push(`to=${this.formModel.toPort.value}`);
      }
      if (this.formModel.oneway && this.formModel.oneway.value) {
        params.push('oneway=true');
      }
      
      // Display options
      const options = this.formModel.buildOptionsString ? this.formModel.buildOptionsString() : '';
      if (options) {
        params.push(`options=${options}`);
      }
      
      return params.length > 0 ? `?${params.join('&')}` : '';
    },
    // the iframeCode is ready for user to use it inside blog or site
    //on the other hand the iframePreview is only a preview so we dont want to be functional,
    // that s why we never pass affiliate code there
    boundCodeForWidgetPreview() {
      switch (this.formModel.variant.value) {
        case 'simple':
          this.iframeHeight = 420;
          break;
        case 'small':
          this.iframeHeight = 360;
          break;
        case 'xsmall':
          this.iframeHeight = 310;
          break;
      }

      const embedPath = `/${this.formModel.language.value}/embed/${this.formModel.variant.value}`;
      
      this.iframeCode = `<iframe width="${this.iframeWidth}" height="${this.iframeHeight}" scrolling="no" frameborder="0" src="${this.baseDomain}${embedPath}${this.buildUrlParams}"></iframe>`;
      this.iframePreview = `<iframe width="${this.iframeWidth}" height="${this.iframeHeight}" scrolling="no" frameborder="0" src="${this.baseDomain}${embedPath}${this.buildPreviewUrlParams}"></iframe>`;

      return this.iframePreview;
    },
    // Key to force iframe re-render when settings change
    previewKey() {
      return `${this.formModel.variant.value}-${this.formModel.language.value}-${this.buildPreviewUrlParams}`;
    },
  },
  methods: {
    // handle the on click event in copy to clipboard button
    clickedCopyToClipboard(textToCopy) {
      let temporaryInputElement = document.createElement("input");
      this.copyToClipboard(temporaryInputElement, textToCopy)
    },
    // we create a temporary input and we copy inside the innerText we want to copy to clipboard.
    // after we copy it to clipboard we remove the input again from the DOM
    copyToClipboard(temporaryInputElement, textToCopy) {
      temporaryInputElement.type = "text";
      temporaryInputElement.value = textToCopy;
      document.body.appendChild(temporaryInputElement);
      temporaryInputElement.select();
      document.execCommand("Copy");
      document.body.removeChild(temporaryInputElement);
    },
  }
}
</script>


<style scoped>
.code-block {
  position: relative;
  background-color: #2d2d2d;
  border-radius: 6px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.code-block pre {
  margin: 0;
  padding: 1rem;
  padding-right: 3rem;
  overflow-x: auto;
}

.code-block code {
  background: none;
  color: #f8f8f2;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.85rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-all;
}

.copy-btn--code {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  padding: 0.4rem 0.6rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.copy-btn--code:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.widget-preview-container {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 450px;
}
</style>
